import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap';
import { getCmTrophySansads } from '../../../services/adminApiService/cmTrophyApi/cmTrophyApi';

const CmTrophySansadFilter = ({ className = " ", value, onChange, disabled = false }) => {
    const [sansadList, setSansadList] = useState([]);

    useEffect(() => {
        getCmTrophySansads()
            .then((res) => setSansadList(res?.data?.data || []))
            .catch(() => setSansadList([]));
    }, []);

    return (
        <>
            <div className="">
                <Form.Select
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    className={`me-2 ${className}`}
                    style={{ width: "100%", padding: "11px 50px 10px 11px" }}
                    disabled={disabled}
                > <option value="">All Sansad</option>
                    {sansadList.map((item) => {
                        return (
                            <option key={item.id} value={item.id}>{item?.name}</option>
                        )
                    })}
                </Form.Select>
            </div>
        </>
    )
}

export default CmTrophySansadFilter
